import { useMutation } from "@tanstack/react-query";
import React from "react";
import { downloadAccountFileApi } from "../../../../../api/correspondent/CorresspondentApi";
import { DownloadFileType } from "../../../../../types/common/basic";
import { downloadFile } from "../../../../../util/FileDownload";

type Props = {};

/**
 * 거래처 파일 다운로드
 * @param props
 * @returns
 */
export const useDownloadAccountFile = () => {
  const { mutate } = useMutation({
    mutationFn: (data: DownloadFileType) => downloadAccountFileApi(data),
    onSuccess: (res, variables) => {
      if (res instanceof Blob) {
        downloadFile(res, variables?.fileOrgname);
      }
    },
  });

  return { mutate };
};
